module.exports = __webpack_public_path__ + "img/globe-white.565e666a.svg";